
export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="container mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-8">
          <div className="md:col-span-2">
            <div className="flex items-center space-x-3 mb-6">
              <img 
                src="https://static.readdy.ai/image/66655080ea9d0ab133a9e87e75781e15/a18a5fcdae7a36cfccaa78b99af85195.png" 
                alt="See Media - Mídia Inteligente" 
                className="h-10 w-auto object-contain max-w-none"
                style={{ minWidth: '100px' }}
                onError={(e) => {
                  console.log('Erro ao carregar logo no footer:', e);
                  e.currentTarget.style.display = 'none';
                }}
                onLoad={() => console.log('Logo do footer carregado com sucesso')}
              />
            </div>
            <p className="text-gray-300 leading-relaxed mb-6 max-w-md">
              Revolucionando o mercado de Digital Out-of-Home com Inteligência Artificial. 
              Conectamos marcas ao público certo, no momento certo.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-blue-600 transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-blue-600 transition-colors cursor-pointer">
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-blue-600 transition-colors cursor-pointer">
                <i className="ri-twitter-x-line text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Soluções</h3>
            <ul className="space-y-2">
              <li><a href="#tecnologia" className="text-gray-300 hover:text-white transition-colors cursor-pointer">Tecnologia IA</a></li>
              <li><a href="#mercados" className="text-gray-300 hover:text-white transition-colors cursor-pointer">Mercados</a></li>
              <li><a href="#sobre" className="text-gray-300 hover:text-white transition-colors cursor-pointer">Sobre Nós</a></li>
              <li><a href="#contato" className="text-gray-300 hover:text-white transition-colors cursor-pointer">Contato</a></li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Contato</h3>
            <ul className="space-y-2 text-gray-300">
              <li className="flex items-center">
                <i className="ri-mail-line mr-2"></i>
                contato@seemedia.com.br
              </li>
              <li className="flex items-center">
                <i className="ri-map-pin-line mr-2"></i>
                Avenida Presidente Vargas, 1265, sala 1405
              </li>
              <li className="flex items-center">
                <i className="ri-phone-line mr-2"></i>
                (11)  99266-4829
              </li>
              <li className="flex items-center">
                <i className="ri-time-line mr-2"></i>
                Seg-Sex, 8h às 18h
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © {currentYear} See Media. Todos os direitos reservados.
          </p>
          {/* <div className="flex items-center space-x-4 mt-4 md:mt-0">
            <a href="" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer">
              
            </a>
          </div> */}
        </div>
      </div>

      <div class="whatsapp-float">
  <a href="https://wa.me/5511992664829" target="_blank" class="whatsapp-btn">
    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="#fff" viewBox="0 0 24 24">
      <path d="M20.52 3.48A11.77 11.77 0 0 0 12 0a11.77 11.77 0 0 0-8.52 3.48A11.77 11.77 0 0 0 0 12a11.63 11.63 0 0 0 1.53 5.75L0 24l6.41-1.68A11.94 11.94 0 0 0 12 23.7a11.77 11.77 0 0 0 8.52-3.48A11.77 11.77 0 0 0 24 12a11.77 11.77 0 0 0-3.48-8.52ZM12 21.47a9.41 9.41 0 0 1-4.79-1.3l-.34-.2-3.8 1 1-3.69-.25-.37a9.47 9.47 0 1 1 8.18 4.56Zm5.34-7.15c-.29-.15-1.73-.85-2-1s-.47-.15-.66.15-.76 1-.93 1.2-.34.22-.63.07a7.57 7.57 0 0 1-2.23-1.38 8.36 8.36 0 0 1-1.55-1.92c-.16-.26 0-.4.12-.54s.29-.34.44-.51a1.79 1.79 0 0 0 .29-.49.47.47 0 0 0 0-.46c-.07-.15-.66-1.58-.9-2.16s-.48-.5-.66-.51h-.57a1.1 1.1 0 0 0-.8.38 3.31 3.31 0 0 0-1 2.46 5.75 5.75 0 0 0 1.21 2.88A12.86 12.86 0 0 0 12 16.92a6.08 6.08 0 0 0 3.44 1h0a3.08 3.08 0 0 0 2-.64 2.43 2.43 0 0 0 .84-1.56c.09-.15 0-.24-.06-.31Z"/>
    </svg>
    <span>Fale Conosco</span>
  </a>
</div>
    </footer>
  );
}